import React, { useState, useEffect, useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { Tooltip } from '@mui/material';
import { MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // Ícone para "finalizar"
import IconButton from '@mui/material/IconButton';
import BuildIcon from '@mui/icons-material/Build'; // Ícone para representar "Área Técnica"
import SettingsIcon from '@mui/icons-material/Settings';
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong"; // ícone para "Ordem de Compra"
import LabelIcon from '@mui/icons-material/Label';

import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import TextField from '@material-ui/core/TextField';
import RefreshIcon from '@mui/icons-material/Refresh';
import Cookies from 'js-cookie';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import AppBar from '@mui/material/AppBar';
import Box from '@material-ui/core/Box';
import { useHistory } from "react-router-dom";
import moment from 'moment';
import { useParams } from "react-router-dom";
import SwipeableViews from 'react-swipeable-views';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';
import { styled } from '@material-ui/styles';
import { Card, CardContent } from '@mui/material';
import { Link } from 'react-router-dom';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CheckIcon from '@mui/icons-material/Check';
import { useDropzone } from 'react-dropzone';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CancelIcon from '@mui/icons-material/Cancel';
import AssignmentIcon from '@mui/icons-material/Assignment';
import WorkIcon from '@mui/icons-material/Work';
import PersonIcon from '@mui/icons-material/Person';
import GroupIcon from '@mui/icons-material/Group';
import DescriptionIcon from '@mui/icons-material/Description';
import BusinessIcon from '@mui/icons-material/Business';
import EngineeringIcon from '@mui/icons-material/Engineering';
import EventNoteIcon from '@mui/icons-material/EventNote';
import InfoIcon from '@mui/icons-material/Info';
import StoreIcon from '@mui/icons-material/Store';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import ScienceIcon from '@mui/icons-material/Science';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import TimerIcon from '@mui/icons-material/Timer';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { calculateBusinessHoursBetween, formatBusinessDuration } from './SLAUtils';

import api from '../../../../../services/api';
import SNARonda from '../../../../../pages/painelAdmin/AreaGestao/ModuloOperacional/RondaVirtual/snaRonda';
import miniatura_pdf from '../../../../../assets/imgs/miniatura_pdf.png';

import MenuRecursosAdministrativos from '../components/menu';
import NavegadorGestao from "../../../../../components/NavBarGestao";
import {
    DataGrid, 
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
} from '@mui/x-data-grid';
import { AddToQueueOutlined, LaptopWindows } from '@material-ui/icons';

import GerenciarTratamentoEmCampo from './gerenciarTratamentoEmCampo';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'; // Ícone apropriado
import ComputerOutlinedIcon from '@mui/icons-material/ComputerOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import EngineeringOutlinedIcon from '@mui/icons-material/EngineeringOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import ChecklistOutlinedIcon from '@mui/icons-material/ChecklistOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';

import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";


const ColorButtonBlue = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'blue',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'blue',
        color: 'whit',
        borderColor: 'red',
    },
}));


const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& .cabecalho_transparente': {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            color: 'rgba(0, 0, 0, 0)',
        },
        '& .cabecalho_azul': {
            backgroundColor: 'rgba(0, 0, 255, 1)',
            color: 'white',
        },
        '& .cabecalho_verde': {
            backgroundColor: 'rgba(0, 100, 0, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_claro': {
            backgroundColor: 'rgba(107,142,35, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_claro': {
            backgroundColor: 'rgba(184,134,11, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_cyan': {
            backgroundColor: 'rgba(0,139,139, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_dark_sea': {
            backgroundColor: 'rgba(60,179,113, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_escuro': {
            backgroundColor: 'rgba(139,69,19, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_chocolate': {
            backgroundColor: 'rgba(210,105,30, 1)',
            color: 'white',
        },
        '& .cabecalho_darkslate': {
            backgroundColor: 'rgba(47,79,79, 1)',
            color: 'white',
        },
        '& .super-app.negative': {
            backgroundColor: 'rgba(157, 255, 118, 0.49)',
            color: '#1a3e72',
            fontWeight: '600',
        },
        '& .super-app.positive': {
            backgroundColor: '#d47483',
            color: '#1a3e72',
            fontWeight: '600',
        },
        '& .super-app.neutro': {
            backgroundColor: '#363636',
            color: 'white',
            fontWeight: '600',
        },
    },

    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
}));

const ColorButtonRed = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'red',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'red',
        color: 'whit',
        borderColor: 'blue',
    },
}));




const ColorButtonGreen = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'green',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'green',
        color: 'whit',
        borderColor: 'blue',
    },
}));




const dropzoneStyles = (themeHelper) => ({
    border: `4px dashed ${themeHelper.border}`,
    borderRadius: '4px',
    padding: '2px',
    textAlign: 'center',
    cursor: 'pointer',
    margin: '2px 0',
});

const InfoBlock = ({ icon: Icon, label, value, themeHelper, color = "#1976d2", maxLines, border }) => {
    const isTruncated = maxLines && value && value.length > 50;

    const content = (
        <Box style={{
            display: 'flex',
            alignItems: 'center',
            padding: '12px',
            backgroundColor: border ? (themeHelper.paper === '#121212' ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)') : 'transparent',
            border: border ? `1px solid ${themeHelper.border}` : 'none',
            borderRadius: '8px',
            height: '100%',
            transition: 'all 0.3s ease'
        }}>
            <Icon style={{ color: color, marginRight: '16px', fontSize: '28px' }} />
            <Box style={{ flex: 1, minWidth: 0 }}>
                <Typography variant="caption" style={{ color: themeHelper.text, opacity: 0.7, display: 'block', fontWeight: 'bold', textTransform: 'uppercase', fontSize: '0.65rem', marginBottom: '2px' }}>
                    {label}
                </Typography>
                <Typography
                    variant="body2"
                    style={{
                        color: themeHelper.text,
                        fontWeight: 500,
                        lineHeight: 1.2,
                        display: '-webkit-box',
                        WebkitLineClamp: maxLines || 'none',
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        wordBreak: 'break-word'
                    }}
                >
                    {value || '---'}
                </Typography>
            </Box>
        </Box>
    );

    return isTruncated ? (
        <Tooltip title={<Typography variant="body2">{value}</Typography>} arrow placement="right">
            {content}
        </Tooltip>
    ) : content;
};



export default function CabecalhoInformacoes2({ compra, ordemCompra, ordemServico, solicitantesSelecionados, ped, instalacaoSelecionada, solicitacaoSelecionada, projetoSelecionado, propostaSelecionada, solicitante, analista, rondaVirtual, entradaEstoque }) {

    const [darkMode, setDarkMode] = useState(Cookies.get('darkMode') === 'true');

    useEffect(() => {
        const handleDarkModeChange = () => {
            setDarkMode(Cookies.get('darkMode') === 'true');
        };

        window.addEventListener('darkModeChanged', handleDarkModeChange);
        window.addEventListener('focus', handleDarkModeChange);

        return () => {
            window.removeEventListener('darkModeChanged', handleDarkModeChange);
            window.removeEventListener('focus', handleDarkModeChange);
        };
    }, []);

    const themeHelper = {
        paper: darkMode ? '#121212' : '#ffffff',
        text: darkMode ? '#ffffff' : '#000000',
        border: darkMode ? '#ffffff' : '#000000',
    };

    const parseBackendDate = useCallback((date) => {
        if (!date) return null;
        if (Array.isArray(date)) {
            // Jackson LocalDateTime [year, month, day, hour, minute, second]
            // Month is 1-indexed in Jackson, 0-indexed in moment
            return moment([date[0], date[1] - 1, date[2], date[3] || 0, date[4] || 0, date[5] || 0]);
        }
        // If it's a string, moment handles ISO and common formats
        return moment(date);
    }, []);

    const [eventosAtivos, setEventosAtivos] = useState([]);

    useEffect(() => {
        const fetchEventos = async () => {
            try {
                const response = await api.get('/v1/protected/eventoglobal/listartodos', {
                    headers: { 'Authorization': 'Bearer ' + Cookies.get('token') }
                });
                setEventosAtivos(response.data.filter(e => e.status === 1));
            } catch (err) {
                console.error("Erro ao carregar feriados:", err);
            }
        };
        fetchEventos();
    }, []);

    const dataCriacaoParsed = ordemServico ? parseBackendDate(ordemServico.data_hora_criacao) : entradaEstoque ? parseBackendDate(entradaEstoque.data_criacao) : '';
    const dataLimiteParsed = ordemServico ? parseBackendDate(ordemServico.data_limite_sla) : null;

    const renderSLADados = () => {
        if (!ordemServico || !dataLimiteParsed) return null;

        const agora = moment();
        const limite = dataLimiteParsed;

        // Tempo Decorrido (Tempo Real)
        const realMinutesDecorrido = agora.diff(dataCriacaoParsed, 'minutes');
        const decorridoTexto = formatBusinessDuration(realMinutesDecorrido);

        // Tempo Restante (Horas Úteis)
        const businessMinutesRestante = calculateBusinessHoursBetween(agora, limite, eventosAtivos);
        const statusNoPrazo = businessMinutesRestante >= 0;
        const restanteTexto = statusNoPrazo 
            ? formatBusinessDuration(businessMinutesRestante)
            : `Violado por ${formatBusinessDuration(Math.abs(businessMinutesRestante))}`;

        // Prioridade
        let prioridadeLabel = "Comum (72h)";
        let prioridadeColor = "#757575";
        const nivel = ordemServico.nivel_prioridade ? parseInt(ordemServico.nivel_prioridade) : 0;
        if (nivel === 1) { prioridadeLabel = "Urgente (48h)"; prioridadeColor = "#ff9800"; }
        if (nivel === 2) { prioridadeLabel = "Priorizar (24h)"; prioridadeColor = "#f44336"; }

        return (
            <>
                <Grid item xs={12} sm={6} md={3}>
                    <InfoBlock
                        icon={PriorityHighIcon}
                        label="Prioridade / SLA"
                        value={prioridadeLabel}
                        themeHelper={themeHelper}
                        color={prioridadeColor}
                        border
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <InfoBlock
                        icon={AccessTimeIcon}
                        label="SLA Limite"
                        value={limite.format('DD/MM/YYYY HH:mm')}
                        themeHelper={themeHelper}
                        color="#1976d2"
                        border
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <InfoBlock
                        icon={TimerIcon}
                        label="Tempo Decorrido"
                        value={decorridoTexto}
                        themeHelper={themeHelper}
                        color="#4caf50"
                        border
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <InfoBlock
                        icon={HourglassEmptyIcon}
                        label="Status SLA"
                        value={statusNoPrazo ? `No Prazo (${restanteTexto})` : `VIOLADO (${restanteTexto})`}
                        themeHelper={themeHelper}
                        color={statusNoPrazo ? "#4caf50" : "#f44336"}
                        border
                    />
                </Grid>
            </>
        );
    };

    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);

    }


    const handleChangeIndex = (index) => {
        setValue(index);
    };



    function returnDescricaoFornecedor(fornecedor) {
        var texto = "Fornecedor_ID: " + fornecedor.id_fornecedor + "\nCPF/CNPJ: " + (fornecedor.tipo_fornecedor === 0 ? fornecedor.cpf : fornecedor.cnpj) +
            "\nNome/Nome Fantasia: " + (fornecedor.tipo_fornecedor === 0 ? (fornecedor.nome + " " + fornecedor.sobrenome) : fornecedor.nome_fantasia);

        return texto;
    }

    const handleAbrirOrdemCompra = (id_ordem_compra) => {
        console.log("Abrir Ordem de Compra");
        window.open(
            "/gestao/administracao/ordensdecompras/editar/" + id_ordem_compra,
            "_blank" // abre em nova aba
        );
    };


    const handleAbrirCompra = (idOrdemCOmpra, id_pre_cotacao) => {
        console.log("Abrir Compra");
        window.open(
            "/gestao/administracao/ordensdecompras/editar/" + idOrdemCOmpra + "/editarcotacao/" + id_pre_cotacao,
            "_blank" // abre em nova aba
        );
    };

    function returnDescricaoOrdem(ordem) {
        var texto = "Ordem_ID: " + ordem.id_ordem_compra + "\nDescrição da Ordem: " + ordem.descricao;
        return texto;
    }


    function returnDescricaoExecutor(usuario) {
        var texto = "ID_Usuario: " + usuario.id_usuario + "\n Nome: " + usuario.nome_amigavel;
        return texto;
    }

    function returnDescricaoCompra(compra) {
        var texto = "Compra_ID: " + compra.id_pre_cotacao + "\nFornecedor: " + compra.nome_fornecedor_amigavel + "\nValor: " + (compra.valor_total + compra.valor_frete);
        return texto;
    }

    function returnDescricaoInstalacao(instalacao) {
        var texto = "SIGMA: " + instalacao.identificador_integrador + "\n Instalacao_ID: " + instalacao.id_instalacao + "\n CPF/CNPJ: " + (instalacao.tipo_instalacao === 0 ? instalacao.cpf : instalacao.cnpj) +
            "\n Nome/Nome Fantasia: " + (instalacao.tipo_instalacao === 0 ? (instalacao.nome + " " + instalacao.sobrenome) : instalacao.nome_fantasia);

        return texto;
    }




    function returnDescricaoProjeto(projeto) {
        try {
            if (!projeto) return "Projeto não informado";

            const texto =
                (projeto.id_projeto || "") + " - " + (projeto.nome_projeto || "") + "\n" +
                (projeto.descricao_projeto || "") + "\n" +
                (projeto.instalacao ? returnDescricaoInstalacao(projeto.instalacao) : "");

            return texto;
        } catch (e) {
            console.error("Erro ao montar descrição do projeto:", e);
            return "Erro ao obter dados do projeto";
        }
    }

    function returnDescricaoProposta(proposta) {
        var texto = proposta.id_proposta + " - " + proposta.descricao_proposta;
        return texto;
    }
    function returnDescricaoProjetoPeD(projeto) {
        var texto = projeto.id_projeto + " - " + projeto.descricao_projeto;
        return texto;
    }

    function returnDescricaoSolicitante(usuario) {
        try {
            var texto = "ID_Usuario: " + usuario.id_usuario + "\n Nome: " + usuario.nome_amigavel;
            return texto;
        } catch (_err) {
            console.log("erro ao retornar descrição do solicitante: " + _err);
            return "Dado invalido";
        }

    }

    const handleClickGerenciarInstalacao = (id_instalacao_loc) => {
        const url = `/gestao/administracao/clientes/gerenciarcliente/instalacao/gerenciarinstalacao/${id_instalacao_loc}/0`;
        window.open(url, '_blank');
    };


    function returnDescricaoSolicitacao(solicitacao) {
        var texto = "Solicitação: " + solicitacao.solicitacao + "\n Descrição: " + solicitacao.descricao;
        return texto;
    }


    function returnDescricaoCategoria(categoria) {
        var texto = '';
        if (categoria === 0) {
            texto = "Projeto 🗂️";
        }
        else if (categoria === 1) {
            texto = "Pesquisa & Desenvolvimento 💻";
        }
        else if (categoria === 2) {
            texto = "Serviços e Manutenção 🛠️";
        }
        else if (categoria === 3) {
            texto = "Renovar Estoque 🛒";
        }
        else if (categoria === 5) {
            texto = "Operação de Entrada de Estoque";
        }
        return texto;
    }



    function returnDescricaoEntradaEstoque() {
        var texto = "Operação de Entrada de Estoque";

        return texto;
    }

    const [openSnaRondaVirtual, setOpenSnaRondaVirtual] = useState(false);

    function handleOpenSnaRondaVirtual() {

        setOpenSnaRondaVirtual(true);

    }


    const handleCloseSnaRondaVirtual = () => {

        setOpenSnaRondaVirtual(false);
    };


    const handleOnClickAreaTecnica = () => {
        // Montando o URL
        const url = `/tecnica/monitoramento/dashboard/${instalacaoSelecionada.id_instalacao}/${instalacaoSelecionada.identificador_integrador}`;

        // Abrindo o URL em uma nova guia
        window.open(url, '_blank');
    };



    return (
        <div style={{ backgroundColor: themeHelper.paper, color: themeHelper.text, minHeight: '100%' }}>
            <Grid container
                alignItems="center"
                justifyContent="center"
            >

                <Grid
                    item xs={12}
                    container
                    direction="row"
                    alignItems="center"
                    justifyContent={"center"}
                    style={{ marginRight: 10, marginLeft: 10 }}
                >


                    <Box style={{ width: '100%', marginBottom: '16px' }}>
                        <Box borderBottom={1} borderColor={darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}>
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                TabIndicatorProps={{
                                    style: {
                                        backgroundColor: '#1976d2',
                                        height: 3,
                                        borderRadius: '3px 3px 0 0'
                                    }
                                }}
                                textColor="inherit"
                                variant="scrollable"
                                scrollButtons="auto"
                                style={{ minHeight: '40px' }}
                            >
                                <Tab
                                    label="Dados"
                                    style={{
                                        textTransform: 'none',
                                        fontWeight: 600,
                                        fontSize: '0.85rem',
                                        minHeight: '40px',
                                        padding: '6px 16px',
                                        color: value === 0 ? '#1976d2' : themeHelper.text
                                    }}
                                />
                                <Tab
                                    label="Imagens"
                                    style={{
                                        textTransform: 'none',
                                        fontWeight: 600,
                                        fontSize: '0.85rem',
                                        minHeight: '40px',
                                        padding: '6px 16px',
                                        color: value === 1 ? '#1976d2' : themeHelper.text
                                    }}
                                />
                                <Tab
                                    label="Vídeos"
                                    style={{
                                        textTransform: 'none',
                                        fontWeight: 600,
                                        fontSize: '0.85rem',
                                        minHeight: '40px',
                                        padding: '6px 16px',
                                        color: value === 2 ? '#1976d2' : themeHelper.text
                                    }}
                                />
                                <Tab
                                    label="Documentos"
                                    style={{
                                        textTransform: 'none',
                                        fontWeight: 600,
                                        fontSize: '0.85rem',
                                        minHeight: '40px',
                                        padding: '6px 16px',
                                        color: value === 3 ? '#1976d2' : themeHelper.text
                                    }}
                                />
                            </Tabs>
                        </Box>
                    </Box>
                </Grid>

                <SwipeableViews
                    index={value}
                    onChangeIndex={handleChangeIndex}
                    style={{ backgroundColor: themeHelper.paper, width: '100%', alignItems: 'center', }}
                >

                    <Grid
                        style={{ padding: 30 }}
                        container
                        direction="row"
                        item xs={12}
                        alignItems="center"
                        justifyContent="center"
                        spacing={1}
                        value={value} index={0}

                    >


                        <Paper
                            elevation={0}
                            style={{
                                padding: '24px',
                                backgroundColor: 'transparent',
                                width: '100%',
                                border: `1px solid ${darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}`,
                                borderRadius: '12px',
                                marginTop: '20px'
                            }}
                        >
                            <Grid container spacing={2}>
                                {renderSLADados()}
                                {
                                    ordemServico &&
                                    (
                                        <Grid item xs={12} sm={6}>
                                            <InfoBlock
                                                icon={LabelIcon}
                                                label="Categoria"
                                                value={returnDescricaoCategoria(ordemServico.categoria_ordem)}
                                                themeHelper={themeHelper}
                                                color="#795548"
                                                border
                                            />
                                        </Grid>
                                    )
                                }

                                {
                                    entradaEstoque && !ordemServico &&
                                    (
                                        <Grid item xs={12} sm={6}>
                                            <InfoBlock
                                                icon={LabelIcon}
                                                label="Categoria"
                                                value={returnDescricaoEntradaEstoque()}
                                                themeHelper={themeHelper}
                                                color="#795548"
                                                border
                                            />
                                        </Grid>
                                    )
                                }


                                {ordemCompra && (
                                    <>
                                        <Grid item xs={12} sm={6}>
                                            <Box style={{ border: `1px solid ${themeHelper.border}`, borderRadius: '8px', padding: '4px', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                <InfoBlock
                                                    icon={ReceiptLongIcon}
                                                    label="Ordem de Compra"
                                                    value={returnDescricaoOrdem(ordemCompra)}
                                                    themeHelper={themeHelper}
                                                    color="#ff5722"
                                                />
                                                <Button
                                                    variant="outlined"
                                                    size="small"
                                                    color="primary"
                                                    style={{ margin: '8px' }}
                                                    onClick={() => handleAbrirOrdemCompra(ordemCompra.id_ordem_compra)}
                                                    disabled={!ordemCompra.id_ordem_compra}
                                                >
                                                    Abrir OC
                                                </Button>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Box style={{ border: `1px solid ${themeHelper.border}`, borderRadius: '8px', padding: '4px', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                <InfoBlock
                                                    icon={ShoppingBagIcon}
                                                    label="Compra"
                                                    value={returnDescricaoCompra(compra)}
                                                    themeHelper={themeHelper}
                                                    color="#e91e63"
                                                />
                                                <Box style={{ display: 'flex', gap: '8px', margin: '8px' }}>
                                                    {compra?.caminho_arquivo && (
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => {
                                                                const link = compra.caminho_arquivo.replaceAll("/home/wwgrup/ordensdecompra/", "https://gruporosinetos.com/ocmidias/");
                                                                window.open(link, "_blank", "noopener,noreferrer");
                                                            }}
                                                        >
                                                            <InsertDriveFileIcon color="primary" />
                                                        </IconButton>
                                                    )}
                                                    <Button
                                                        variant="outlined"
                                                        size="small"
                                                        color="primary"
                                                        onClick={() => handleAbrirCompra(ordemCompra.id_ordem_compra, compra.id_pre_cotacao)}
                                                    >
                                                        Abrir Compra
                                                    </Button>
                                                </Box>
                                            </Box>
                                        </Grid>
                                    </>
                                )}

                                {ordemServico?.categoria_ordem === 0 && (
                                    <>
                                        {projetoSelecionado && (
                                            <Grid item xs={12} sm={6}>
                                                <InfoBlock
                                                    icon={AssignmentIcon}
                                                    label="Projeto"
                                                    value={returnDescricaoProjeto(projetoSelecionado)}
                                                    themeHelper={themeHelper}
                                                    color="#4caf50"
                                                    border
                                                />
                                            </Grid>
                                        )}
                                        {propostaSelecionada && (
                                            <Grid item xs={12} sm={6}>
                                                <InfoBlock
                                                    icon={WorkIcon}
                                                    label="Proposta"
                                                    value={returnDescricaoProposta(propostaSelecionada)}
                                                    themeHelper={themeHelper}
                                                    color="#ff9800"
                                                    border
                                                />
                                            </Grid>
                                        )}
                                    </>
                                )}

                                {ordemServico?.categoria_ordem === 1 && ped && (
                                    <Grid item xs={12} sm={6}>
                                        <Box style={{ border: `1px solid ${themeHelper.border}`, borderRadius: '8px', padding: '4px', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <InfoBlock
                                                icon={ScienceIcon}
                                                label="Projeto P&D"
                                                value={returnDescricaoProjetoPeD(ped)}
                                                themeHelper={themeHelper}
                                                color="#673ab7"
                                            />
                                            <Tooltip title="Gerenciar">
                                                <IconButton
                                                    color="primary"
                                                    style={{ margin: '8px' }}
                                                    href={`/gestao/administracao/ped/editarprojeto/${ped.id_projeto}`}
                                                    target="_blank"
                                                >
                                                    <SettingsIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </Box>
                                    </Grid>
                                )}

                                {ordemServico?.categoria_ordem === 2 && instalacaoSelecionada && (
                                    <Grid item xs={12} sm={6}>
                                        <Box style={{ border: `1px solid ${themeHelper.border}`, borderRadius: '8px', padding: '4px', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <InfoBlock
                                                icon={BusinessIcon}
                                                label="Instalação"
                                                value={returnDescricaoInstalacao(instalacaoSelecionada)}
                                                themeHelper={themeHelper}
                                                color="#607d8b"
                                            />
                                            <Box style={{ display: 'flex', gap: '8px', margin: '8px' }}>
                                                <IconButton size="small" color="primary" onClick={() => handleClickGerenciarInstalacao(instalacaoSelecionada.id_instalacao)}>
                                                    <SettingsIcon />
                                                </IconButton>
                                                <Button
                                                    variant="outlined"
                                                    size="small"
                                                    color="primary"
                                                    startIcon={<BuildIcon />}
                                                    onClick={handleOnClickAreaTecnica}
                                                >
                                                    Área Técnica
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Grid>
                                )}

                                {
                                    solicitacaoSelecionada && (
                                        <Grid item xs={12} sm={6}>
                                            <InfoBlock
                                                icon={InfoIcon}
                                                label="Solicitação"
                                                value={returnDescricaoSolicitacao(solicitacaoSelecionada)}
                                                themeHelper={themeHelper}
                                                color="#9c27b0"
                                                border
                                                maxLines={2}
                                            />
                                        </Grid>

                                    )
                                }

                                {solicitante && (
                                    <Grid item xs={12} sm={6}>
                                        <InfoBlock
                                            icon={PersonIcon}
                                            label="Usuário Solicitador"
                                            value={returnDescricaoSolicitante(solicitante).replace(/<br \/>/g, ' ')}
                                            themeHelper={themeHelper}
                                            color="#f44336"
                                            border
                                        />
                                    </Grid>
                                )}

                                {analista && (
                                    <Grid item xs={12} sm={6}>
                                        <InfoBlock
                                            icon={EngineeringIcon}
                                            label="Usuário Analista"
                                            value={returnDescricaoSolicitante(analista).replace(/<br \/>/g, ' ')}
                                            themeHelper={themeHelper}
                                            color="#009688"
                                            border
                                        />
                                    </Grid>
                                )}

                                {rondaVirtual && (
                                    <Grid item xs={12} sm={6}>
                                        <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', border: `1px solid ${themeHelper.border}`, borderRadius: '8px', padding: '4px 12px', height: '100%' }}>
                                            <InfoBlock
                                                icon={VisibilityIcon}
                                                label="Ronda Virtual"
                                                value={`Nº ${rondaVirtual.id_ronda_virtual}`}
                                                themeHelper={themeHelper}
                                                color="#4caf50"
                                            />
                                            <IconButton size="small" onClick={() => handleOpenSnaRondaVirtual(rondaVirtual)} style={{ color: 'green' }}>
                                                <VisibilityIcon />
                                            </IconButton>
                                        </Box>
                                    </Grid>
                                )}

                                {ordemServico && (
                                    <Grid item xs={12} md={8}>
                                        <Box style={{
                                            padding: '16px',
                                            borderRadius: '8px',
                                            borderLeft: `5px solid #607d8b`,
                                            backgroundColor: darkMode ? 'rgba(96, 125, 139, 0.1)' : 'rgba(96, 125, 139, 0.05)',
                                            height: '100%'
                                        }}>
                                            <InfoBlock
                                                icon={DescriptionIcon}
                                                label="Descrição da Solicitação"
                                                value={ordemServico.descricao_solicitacao}
                                                themeHelper={themeHelper}
                                                color="#607d8b"
                                            />
                                        </Box>
                                    </Grid>)}


                                {ordemServico && (
                                    <Grid item xs={12} md={4}>
                                        <Box style={{
                                            padding: '16px',
                                            borderRadius: '8px',
                                            border: `1px dashed ${themeHelper.border}`,
                                            backgroundColor: darkMode ? 'rgba(255, 255, 255, 0.02)' : 'rgba(0, 0, 0, 0.01)',
                                            height: '100%',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center'
                                        }}>
                                            <Typography variant="caption" style={{ color: themeHelper.text, opacity: 0.6, fontWeight: 'bold', textTransform: 'uppercase', fontSize: '0.6rem' }}>
                                                Histórico de Criação
                                            </Typography>
                                            <Typography variant="body2" style={{ color: themeHelper.text, fontWeight: 500, marginTop: '4px' }}>
                                                Criado por: <strong>{ordemServico.usuario_criador?.nome_amigavel || 'Sistema'}</strong>
                                            </Typography>
                                            <Typography variant="caption" style={{ color: themeHelper.text, opacity: 0.8, marginTop: '2px' }}>
                                                {dataCriacaoParsed ? dataCriacaoParsed.format('DD/MM/YYYY HH:mm') : '---'}
                                            </Typography>
                                            <Typography variant="caption" style={{ color: '#4caf50', fontWeight: 'bold', marginTop: '4px' }}>
                                                {dataCriacaoParsed ? dataCriacaoParsed.fromNow() : ''}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                )}


                                {entradaEstoque && !ordemServico && (
                                    <Grid item xs={12} md={4}>
                                        <Box style={{
                                            padding: '16px',
                                            borderRadius: '8px',
                                            border: `1px dashed ${themeHelper.border}`,
                                            backgroundColor: darkMode ? 'rgba(255, 255, 255, 0.02)' : 'rgba(0, 0, 0, 0.01)',
                                            height: '100%',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center'
                                        }}>
                                            <Typography variant="caption" style={{ color: themeHelper.text, opacity: 0.6, fontWeight: 'bold', textTransform: 'uppercase', fontSize: '0.6rem' }}>
                                                Histórico de Criação
                                            </Typography>
                                            <Typography variant="body2" style={{ color: themeHelper.text, fontWeight: 500, marginTop: '4px' }}>
                                                Criado por: {entradaEstoque.usuario_criador?.nome_amigavel || 'Sistema'}
                                            </Typography>
                                            <Typography variant="caption" style={{ color: themeHelper.text, opacity: 0.8, marginTop: '2px' }}>
                                                {dataCriacaoParsed ? dataCriacaoParsed.format('DD/MM/YYYY HH:mm') : '---'}
                                            </Typography>
                                            <Typography variant="caption" style={{ color: '#4caf50', fontWeight: 'bold', marginTop: '4px' }}>
                                                {dataCriacaoParsed ? dataCriacaoParsed.fromNow() : ''}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                )}
                            </Grid>
                        </Paper>



                    </Grid>
                    {
                        ordemServico && (
                            <Grid
                                value={value} index={1}
                                container
                                direction="row"
                                item xs={12}
                                alignItems="center"
                                justifyContent="center"
                            >


                                <Grid item xs={12}
                                    container
                                    alignItems="center"
                                    justifyContent="center"
                                >

                                    <Grid item xs={12}
                                        container
                                        alignItems="center"
                                        justifyContent="center"
                                    >
                                        <Grid item xs={12} style={{ paddingTop: 10, paddingBottom: 10 }}>
                                            {
                                                ordemServico.caminho_imagem1 &&
                                                <Typography
                                                    variant="h5"
                                                >
                                                    {"Descrição: " + ordemServico.descricao_imagem1}
                                                </Typography>
                                            }

                                        </Grid>
                                        <Grid item xs={12}
                                            container
                                            style={{ paddingBottom: 30 }}
                                        >
                                            {ordemServico.caminho_imagem1 &&
                                                <img
                                                    style={{ maxWidth: '100%', maxHeight: '100%' }}
                                                    src={ordemServico.caminho_imagem1.replace("/home/wwgrup/ordensdeservico/", "https://gruporosinetos.com/osmidias/")} alt="Imagem 1" />
                                            }
                                        </Grid>

                                    </Grid>

                                    <Grid
                                        container
                                        alignItems="center"
                                        justifyContent="center"
                                    >
                                        <Grid item xs={12} style={{ paddingTop: 10, paddingBottom: 10 }}>
                                            {
                                                ordemServico.caminho_imagem2 &&
                                                <Typography
                                                    variant="h5"
                                                >
                                                    {"Descrição: " + ordemServico.descricao_imagem2}
                                                </Typography>
                                            }

                                        </Grid>
                                        <Grid item xs={12}
                                            container
                                            style={{ paddingBottom: 30 }}
                                        >
                                            {ordemServico.caminho_imagem2 &&
                                                <img
                                                    style={{ maxWidth: '100%', maxHeight: '100%' }}
                                                    src={ordemServico.caminho_imagem2.replace("/home/wwgrup/ordensdeservico/", "https://gruporosinetos.com/osmidias/")} alt="Imagem 1" />
                                            }
                                        </Grid>

                                    </Grid>

                                    <Grid
                                        container
                                        alignItems="center"
                                        justifyContent="center"
                                    >
                                        <Grid item xs={12} style={{ paddingTop: 10, paddingBottom: 10 }}>
                                            {
                                                ordemServico.caminho_imagem3 &&
                                                <Typography
                                                    variant="h5"
                                                >
                                                    {"Descrição: " + ordemServico.descricao_imagem3}
                                                </Typography>
                                            }

                                        </Grid>
                                        <Grid item xs={12}
                                            container
                                            style={{ paddingBottom: 30 }}
                                        >
                                            {ordemServico.caminho_imagem3 &&
                                                <img
                                                    style={{ maxWidth: '100%', maxHeight: '100%' }}
                                                    src={ordemServico.caminho_imagem3.replace("/home/wwgrup/ordensdeservico/", "https://gruporosinetos.com/osmidias/")} alt="Imagem 1" />
                                            }
                                        </Grid>

                                    </Grid>

                                    <Grid
                                        container
                                        alignItems="center"
                                        justifyContent="center"
                                    >
                                        <Grid item xs={12} style={{ paddingTop: 10, paddingBottom: 10 }}>
                                            {
                                                ordemServico.caminho_imagem4 &&
                                                <Typography
                                                    variant="h5"
                                                >
                                                    {"Descrição: " + ordemServico.descricao_imagem4}
                                                </Typography>
                                            }

                                        </Grid>
                                        <Grid item xs={12}
                                            container
                                            style={{ paddingBottom: 30 }}
                                        >
                                            {ordemServico.caminho_imagem4 &&
                                                <img
                                                    style={{ maxWidth: '100%', maxHeight: '100%' }}
                                                    src={ordemServico.caminho_imagem4.replace("/home/wwgrup/ordensdeservico/", "https://gruporosinetos.com/osmidias/")} alt="Imagem 4" />
                                            }
                                        </Grid>

                                    </Grid>





                                </Grid>

                            </Grid>
                        )
                    }

                    {
                        ordemServico && (
                            <Grid
                                value={value} index={2}
                                container
                                direction="row"
                                item xs={12}
                                alignItems="center"
                                justifyContent="center"
                            >
                            </Grid>
                        )
                    }

                    {
                        ordemServico && (
                            <Grid
                                value={value} index={3}
                                container
                                direction="row"
                                item xs={12}
                                alignItems="center"
                                justifyContent="center"
                            >





                                <Grid item xs={12}
                                    container
                                    alignItems="center"
                                    justifyContent="center"
                                >

                                    <Grid item xs={12}
                                        container
                                        alignItems="center"
                                        justifyContent="center"
                                    >
                                        <Grid item xs={12} style={{ paddingTop: 10, paddingBottom: 10 }}>
                                            {
                                                ordemServico.caminho_arquivo1 &&
                                                <Typography
                                                    variant="h5"
                                                >
                                                    {"Descrição: " + ordemServico.descricao_arquivo1}
                                                </Typography>
                                            }

                                        </Grid>
                                        <Grid item xs={12}
                                            container
                                            style={{ paddingBottom: 30 }}
                                        >
                                            {ordemServico.caminho_arquivo1 &&
                                                <div

                                                    onClick={() => {
                                                        const link = ordemServico.caminho_arquivo1.replaceAll(
                                                            "/home/wwgrup/ordensdeservico/",
                                                            "https://gruporosinetos.com/osmidias/"
                                                        );
                                                        window.open(link, "_blank", "noopener,noreferrer");
                                                    }}
                                                    style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', margin: 0, width: '200px', height: '200px' }}>
                                                    <InsertDriveFileIcon style={{ fontSize: 48, color: "#1976d2" }} />
                                                </div>




                                            }
                                        </Grid>

                                    </Grid>


                                    <Grid item xs={12}
                                        container
                                        alignItems="center"
                                        justifyContent="center"
                                    >
                                        <Grid item xs={12}
                                            style={{ paddingTop: 10, paddingBottom: 10 }}
                                        >
                                            {
                                                ordemServico.caminho_arquivo2 &&
                                                <Typography
                                                    variant="h5"
                                                >
                                                    {"Descrição: " + ordemServico.descricao_arquivo2}
                                                </Typography>
                                            }

                                        </Grid>
                                        <Grid item xs={12}
                                            container
                                            style={{ paddingBottom: 30 }}
                                        >
                                            {ordemServico.caminho_arquivo2 &&
                                                <div
                                                    onClick={() => {
                                                        const link = ordemServico.caminho_arquivo2.replaceAll(
                                                            "/home/wwgrup/ordensdeservico/",
                                                            "https://gruporosinetos.com/osmidias/"
                                                        );
                                                        window.open(link, "_blank", "noopener,noreferrer");
                                                    }}

                                                    style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', margin: 0, width: '200px', height: '200px' }}>
                                                    <InsertDriveFileIcon style={{ fontSize: 48, color: "#1976d2" }} />
                                                </div>



                                            }
                                        </Grid>

                                    </Grid>


                                    <Grid item xs={12}
                                        container
                                        alignItems="center"
                                        justifyContent="center"
                                    >
                                        <Grid item xs={12}
                                            style={{ paddingTop: 10, paddingBottom: 10 }}
                                        >
                                            {
                                                ordemServico.caminho_arquivo2 &&
                                                <Typography
                                                    variant="h5"
                                                >
                                                    {"Descrição: " + ordemServico.descricao_arquivo3}
                                                </Typography>
                                            }

                                        </Grid>
                                        <Grid item xs={12}
                                            container
                                            style={{ paddingBottom: 30 }}
                                        >
                                            {ordemServico.caminho_arquivo3 &&
                                                <div
                                                    onClick={() => {
                                                        const link = ordemServico.caminho_arquivo3.replaceAll(
                                                            "/home/wwgrup/ordensdeservico/",
                                                            "https://gruporosinetos.com/osmidias/"
                                                        );
                                                        window.open(link, "_blank", "noopener,noreferrer");
                                                    }}

                                                    style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', margin: 0, width: '200px', height: '200px' }}>
                                                    <InsertDriveFileIcon style={{ fontSize: 48, color: "#1976d2" }} />
                                                </div>

                                            }
                                        </Grid>

                                    </Grid>





                                </Grid>

                            </Grid>
                        )
                    }








                </SwipeableViews >

            </Grid >

            <Dialog open={openSnaRondaVirtual} onClose={handleCloseSnaRondaVirtual} PaperProps={{ style: { maxWidth: '90%', minWidth: '90%', backgroundColor: themeHelper.paper, color: themeHelper.text } }}>
                <DialogContent>
                    <SNARonda
                        rondaVirtual={rondaVirtual}
                    />
                </DialogContent>
            </Dialog>
        </div >
    );
}


